import { useEffect } from "react";
import { DashboardCanvas } from "./components/DashboardCanvas";
import { FilterBar } from "./shell/FilterBar";
import { LoginScreen } from "./shell/LoginScreen";
import { PageTabs } from "./shell/PageTabs";
import { TopBar } from "./shell/TopBar";
import { FINANCE_ENGINE } from "./lib/finance";
import { useStore } from "./store";

export default function App() {
  const status = useStore((s) => s.authStatus);
  const bootAuth = useStore((s) => s.bootAuth);

  useEffect(() => {
    void bootAuth();
  }, [bootAuth]);

  if (status === "checking") return <div className="boot">Loading...</div>;
  if (status === "anon") return <LoginScreen />;

  return (
    <div className="app">
      <TopBar />
      <PageTabs />
      <ConnectionGuard />
    </div>
  );
}

/**
 * Renders the report, or explains why it cannot.
 *
 * Every query on these pages is ClickHouse-specific SQL. Without a ClickHouse
 * connection the widgets would each fail with a parse error that blames the
 * SQL rather than the missing connection -- one clear sentence is worth more
 * than thirty confusing ones.
 */
function ConnectionGuard() {
  const connections = useStore((s) => s.connections);
  const activeId = useStore((s) => s.activeConnectionId);

  if (!activeId) {
    return (
      <div className="engine-notice">
        <span>
          No {FINANCE_ENGINE} connection is available
          {connections.length === 0 ? "" : " for this account"}.
        </span>
        <span className="engine-notice-hint">
          Add one in the Admin console, then reload.
        </span>
      </div>
    );
  }

  return (
    <>
      <FilterBar />
      <div className="workspace">
        <DashboardCanvas />
      </div>
    </>
  );
}
